import React from 'react';
import PartnerHeader from "../../common/components/PartnerHeader";
import Tabs from "../../common/components/Tabs";
import Promotions from "../Promotions";
import { getTabs, TabNames } from "./utils";

var ManagePartners = function ManagePartners(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PartnerHeader, {
    mpacBaseUrl: props.mpacBaseUrl,
    partnerDetails: props.partnerDetails,
    partnerId: props.partnerId,
    showPartnerActions: true,
    isSiteAdmin: props.permissions.isSiteAdmin
  }), /*#__PURE__*/React.createElement(Tabs, {
    tabs: getTabs(props.partnerId, props.permissions),
    selectedTab: props.selectedTab
  }), props.selectedTab === TabNames.PROMOTIONS && /*#__PURE__*/React.createElement(Promotions, {
    partnerId: props.partnerId,
    mpacBaseUrl: props.mpacBaseUrl
  }));
};

export default ManagePartners;